import { BrowseCell } from "../../types";
import { VNode } from "vue";

export interface DefaultBodyScopedSlots
{
    /** The content of a cell, wrapped in the bodyCellContent <div>. */
    bodyCellContent?: (scope: { cell: BrowseCell }) => VNode | VNode[] | undefined
}

export const bodyCellContent = "bodyCellContent";